// src/components/VoucherWelcomeModal.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/VoucherWelcomeModal.css';

const VoucherWelcomeModal = ({ voucherCode, userEmail, onClose }) => {
    const navigate = useNavigate();

    const handleContinue = () => {
        onClose();
        navigate('/login');
    };

    if (!onClose) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2 className="modal-title">Welcome to EdGeneOnline!</h2>
                <p className="modal-message">
                    Thank you for signing up. Here is your exclusive voucher code for one month of free access to our individual plans.
                </p>
                <div className="voucher-display">
                    <p>Your Voucher Code:</p>
                    <div className="voucher-code-box">
                        <strong>{voucherCode}</strong>
                    </div>
                </div>
                <p className="modal-support">
                    If you misplace your voucher, please contact us at <a href="mailto:info@edgeneonline.com">info@edgeneonline.com</a>.
                </p>
                <div className="modal-footer">
                    <button className="modal-button" onClick={handleContinue}>
                        Go to Login
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VoucherWelcomeModal;
